import React, { useEffect, useState, useRef } from "react";
import OneIcon from "../../Images/oneIcon.svg";
import checkGreen from "../../Images/preCheck/checkGreen.svg";
import checkRed from "../../Images/preCheck/checkRed.svg";
import GreenTick from "../../Images/preCheck/GreenTick.svg";
import RedTick from "../../Images/preCheck/RedTick.svg";
import LoadingSpinner from "../Lottie/LoadingSpinner";
import MessageA1i from "./MessageA1i";
import MessageAY3 from "./MessageAY3";
import iconPlus from '../../Images/IconPlus.svg';
import iconMinus from '../../Images/IconMinus.svg';
import MessageA13i from "./MessageA13i";

const MessageA26LLM = (props) => {
    const { scrollToBottom, item, addMessages, setisSubscriber, array, showMaximumChat } = props;
    const llmRes = item?.LLM;

    const [onChecked, setOnChecked] = useState(false);
    const [isPassed, setIsPassed] = useState(false);
    const [loader, setLoader] = useState(false);
    const [isToggled, setIsToggled] = useState(false);
    const [loadedChecks, setLoadedChecks] = useState([]); // Keeps track of loaded checks
    const [loadingComplete, setLoadingComplete] = useState(false); // Track if all checks have loaded
    const checksLoadedRef = useRef(false); // Ref to check if checks have been loaded already
    const [fadeState, setFadeState] = useState([]);

    const handleToggle = () => {
        setIsToggled(!isToggled);
    };

    useEffect(() => {
        const allPassed = item?.checks?.some(check => check.passed === true);
        setIsPassed(!allPassed);
        setLoader(true);

        setTimeout(() => {
            onChecked && setOnChecked(true);
            onChecked && setLoadingComplete(true);
            setLoader(false);
        }, 3000); // Simulate a loader for 3 seconds
    }, []);

    // Function to load checks one by one
    useEffect(() => {
        if (!checksLoadedRef.current && item?.checks?.length) {
            checksLoadedRef.current = true; // Set to true to prevent multiple triggers
            let index = 0;
            const interval = setInterval(() => {
                if (index < item?.checks.length) {
                    const currentCheck = item?.checks[index];
                    // Only add non-empty checks
                    if (currentCheck) {
                        setLoadedChecks((prevChecks) => [...prevChecks, currentCheck]);
                    }
                    index++;
                } else {
                    clearInterval(interval);
                    setLoadingComplete(true); // All checks are loaded
                }
            }, 500); // Adjust the delay to control the loading speed
        }
    }, [item?.checks]); // Only run when `item?.checks` is available

    // Function to smoothly scroll to the latest loaded check
    useEffect(() => {
        if (loadedChecks?.length > 0) {
            const lastCheck = document.getElementById(`check-${loadedChecks.length - 1}`);
            if (lastCheck) {
                lastCheck.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        }
    }, [loadedChecks, loadingComplete]);

    useEffect(() => {
        if (loadedChecks?.length > 0) {
            // Initialize fade state for new checks
            const newFadeState = loadedChecks.map(() => 'fadeIn');
            setFadeState(newFadeState);
        }
    }, [loadedChecks]); // Re-run when new checks are added

    return (
        <div>
            <div style={{ padding: "8px" }} className="header-prob">
                Checklist
            </div>
            <div className="channel-list">
                <div style={{ borderRadius: "8px" }} className="list-of-channels">
                    <div
                        style={{
                            border: onChecked ? `1px solid ${!isPassed ? '#43BF5E' : '#B1350C'}` : "1px solid #ccc",
                            backgroundColor: onChecked ? `${!isPassed ? '#EAF8ED' : '#FEF0EB'}` : "#fff",
                            borderBottom: onChecked ? "none" : "1px solid #ccc",
                            height: "64px",
                            display: "flex",
                            alignItems: "center",
                            gap: "16px",
                            borderRadius: onChecked ? "10px 10px 0px 0px" : "10px",
                            cursor: "pointer",
                        }}
                        className="precheck-header"
                    >
                        <img
                            src={!isPassed && !loader ? GreenTick : RedTick}
                            style={{
                                height: "clamp(32px, 4vw, 72px)",
                                width: "clamp(16px, 4vw, 32px)",
                            }}
                            alt="Icon"
                        />
                        <div>Prechecks</div>
                    </div>

                    {/* Smooth expanding section */}
                    <div
                        style={{
                            height: 'auto',
                            opacity: onChecked ? 1 : 0,
                            overflow: "hidden",
                            borderRadius: "10px",
                            border: onChecked ? `1px solid ${!isPassed ? '#43BF5E' : '#B1350C'}` : "none",
                            backgroundColor: "#fff",
                            transition: "height 1s ease-out, opacity 1s ease-out, transform 1s ease-out",  // Transition max-height for smooth expansion
                            display: "flex",
                            flexDirection: "column",
                            gap: "16px",
                            position: 'relative',
                            transform: onChecked ? "translateY(0)" : "translateY(20px)", // Smooth upward transition
                            bottom: '10px',
                        }}

                        className="precheck-header"
                    >
                                {/* Render checks one by one */}
                                {onChecked &&
                                    loadedChecks
                                        .filter((checkItem) => checkItem?.passed === true) // Filter for passed checks
                                        .map((checkItem, index) => (
                                            <div
                                                key={index}
                                                id={`check-${index}`}
                                                style={{
                                                    margin: "10px 10px 10px 0px",
                                                    display: "flex",
                                                    gap: "10px",
                                                    opacity: fadeState[index] === "fadeIn" ? 1 : fadeState[index] === "fadeOut" ? 0 : 1, // Apply fade-in or fade-out
                                                    transform: fadeState[index] === "fadeIn" ? "translateY(0)" : "translateY(10px)", // Smoothly move into view
                                                    transition: "opacity 1s ease, transform 1s ease", // Apply smooth fade-in/out and movement
                                                }}
                                            >
                                                <img
                                                    style={{ width: "16px" }}
                                                    src={checkGreen} // Since only passed checks are shown, use the green check icon
                                                    alt="Check Icon"
                                                />
                                                <span className="precheck-flow-font">{checkItem?.preChecks}</span>
                                            </div>
                                        ))}

                    </div>

                    {!loader && !isPassed && llmRes?.response && (
                        <div style={{ display: 'flex', marginTop: '4px', alignItems: 'center' }}>
                            <div style={{ fontWeight: '700' }}>Resolution :</div>
                            <img
                                style={{ height: '26px', width: '24px', top: showMaximumChat ? '' : '-15px', marginLeft: '6px' }}
                                key={'plus'}
                                src={isToggled ? iconMinus : iconPlus}
                                onClick={handleToggle}
                            />
                        </div>
                    )}
                    {!loader && isToggled && llmRes?.response && (
                        <div
                            style={{ marginLeft: '4px' }}
                            className="A3f"
                            dangerouslySetInnerHTML={{ __html: llmRes?.response }}
                        />
                    )}
                </div>

                {loader && <LoadingSpinner />}
                {/* Render other components here if necessary */}

                {!loader && array?.map((arrayItem, index) => (
                    <React.Fragment key={arrayItem?.id || index}>
                        {arrayItem?.uiCommand === "AY3" && (
                            <div style={{ marginTop: '36px' }}>
                                <MessageAY3
                                    item={arrayItem}
                                    setisSubscriber={setisSubscriber}
                                    addMessages={addMessages}
                                    loader={loader}
                                />
                            </div>
                        )}
                        {(arrayItem?.uiCommand === "A1i" || arrayItem?.uiCommand === "A1") && (
                            <div style={{ display: "inline-block" }}>
                                <MessageA1i
                                    item={arrayItem}
                                    setisSubscriber={setisSubscriber}
                                    addMessages={addMessages}
                                    loader={loader}
                                />
                            </div>
                        )}
                        {(arrayItem?.uiCommand === "A13i") && (
                                <MessageA13i 
                                    item={arrayItem}
                                    setisSubscriber={setisSubscriber}
                                    addMessages={addMessages}
                                    loader={loader}
                                />
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default MessageA26LLM;
